// TestimonialsSection.jsx
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FiStar } from 'react-icons/fi';
import { BsQuote } from 'react-icons/bs';
import '../../../../assets/css/customer/subscreens/about/StatsSection.css';

const TestimonialsSection = () => {
  const testimonials = [
    {
      id: 1,
      name: 'Ayesha Khan',
      email: 'ayeshakhan@gmail.com',
      rating: 5,
      review: 'Ordered a custom embroidered bag and the seller chatted with me throughout to get the design just right. Loved the final product!',
      avatar: 'AK'
    },
    {
      id: 2,
      name: 'Bilal Ahmed',
      email: 'bilalahmed@gmail.com',
      rating: 5,
      review: 'Cash on Delivery made it so easy to trust the platform. Product quality was even better than the pictures.',
      avatar: 'BA'
    },
    {
      id: 3,
      name: 'Sana Malik',
      email: 'sanamalik@gmail.com',
      rating: 4,
      review: 'Great experience supporting a local artisan directly. Delivery took a couple of days but totally worth the wait.',
      avatar: 'SM'
    }
  ];

  return (
    <section className="testimonials-section">
      <Container>
        <h2 className="section-title-center">What Our Customers Say</h2>
        {/* <p className="section-subtitle-center">
          Real experiences from people who shop with us
        </p> */}

        <Row className="testimonials-grid">
          {testimonials.map((testimonial) => (
            <Col lg={4} md={6} sm={12} key={testimonial.id}>
              <div className="testimonial-card">
                <div className="testimonial-quote-icon">
                  <BsQuote />
                </div>

                <div className="testimonial-rating">
                  {Array.from({ length: 5 }).map((_, index) => (
                    <FiStar
                      key={index}
                      className={index < testimonial.rating ? 'star-filled' : 'star-empty'}
                    />
                  ))}
                </div>

                <p className="testimonial-review">"{testimonial.review}"</p>

                <div className="testimonial-author">
                  <div className="testimonial-avatar">{testimonial.avatar}</div>
                  <div className="testimonial-author-info">
                    <h4 className="testimonial-name">{testimonial.name}</h4>
                    <p className="testimonial-role">{testimonial.email}</p>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default TestimonialsSection;